import { BaseEntityClass } from "@shared/services/event_tracking/entities/base_entity_class";

interface ScreenPositionEntityParams {
  scrollX: number;
  scrollY: number;
  top: number;
  left: number;
  belowFold: boolean;
  outsideInitialView: boolean;
}
export class ScreenPositionEntity extends BaseEntityClass {
  scrollX: number;
  scrollY: number;
  top: number;
  left: number;
  belowFold: boolean;
  outsideInitialView: boolean;

  constructor(params: ScreenPositionEntityParams) {
    super();
    this.type = "screen_position";
    this.entity_version = 2;
    this.scrollX = params.scrollX;
    this.scrollY = params.scrollY;
    this.top = params.top;
    this.left = params.left;
    this.belowFold = params.belowFold;
    this.outsideInitialView = params.outsideInitialView;
  }
}
